/**
 * 创意聊天 - 消息角色枚举
 */
export enum CreativeMessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  SYSTEM = 'system',
}

/**
 * 创意会话接口
 */
export interface ICreativeConversation {
  id: string;
  userId: string;
  title: string;
  modelId?: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

/**
 * 创意消息接口
 */
export interface ICreativeMessage {
  id: string;
  conversationId: string;
  role: CreativeMessageRole;
  content: string;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * 创建会话请求
 */
export interface CreateConversationRequest {
  title?: string;
  modelId?: string;
}

/**
 * 更新会话请求
 */
export interface UpdateConversationRequest {
  title?: string;
  modelId?: string;
}

/**
 * 发送创意消息请求
 */
export interface SendCreativeMessageRequest {
  content: string;
  modelId?: string;
}
